<template>
  <div>
    <Row>
      <Col span="23" offset="1">
        <Col span="4" style="font-size:20px;">联系我们</Col>
        <br />
        <Col span="24" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray">
          <table>
            <tr>
              <td></td>
              <td>电子邮箱</td>
              <td>电话</td>
              <td>联系人</td>
            </tr>
            <tr>
              <td>客户服务</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>媒体联系</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>广告销售/商务合作</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>任何疑问</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </Col>
      </Col>
      <Col span="23" offset="1">
        <Col span="4" style="font-size:20px;">办公地址</Col>
        <Col span="24" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray">
          <Col span="20" offset="2">
            <img width="100%" height="100%" :src="Iimg" />
          </Col>
        </Col>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "connect",
  data() {
    return {
      Iimg: "../../../static/19.jpg",
    };
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  cursor: pointer;
  width: 90%;
  margin: 10px auto;
}
td {
  border: 1px solid lightgray;
  height: 50px;
}
tr {
  border: 1px solid lightgray;
}
tr:hover {
  background: whitesmoke;
}
td:nth-child(2n-1) {
  background: #f5f5f5;
}
img {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/other/components/connect.vue